import api from '@/core/api/client';

export interface Coupon {
  id: string;
  code: string;
  discountStrategy?: string | null;
  value: number;
  durationType?: string | null;
  durationMonths?: number | null;
  usageType?: string | null;
  affiliateId?: string | null;
  description?: string | null;
  maxRedemptions?: number | null;
  redeemedCount: number;
  validFrom?: string | null;
  validUntil?: string | null;
  planIds?: string[] | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCouponData {
  code: string;
  discountStrategy: 'PERCENTAGE' | 'FIXED_AMOUNT' | 'TRIAL_DAYS';
  value: number;
  durationType?: 'ONCE' | 'REPEATING' | 'FOREVER';
  durationMonths?: number;
  usageType?: 'CAMPAIGN' | 'AFFILIATE' | 'INTERNAL';
  affiliateId?: string | null;
  description?: string;
  maxRedemptions?: number;
  validFrom?: string;
  validUntil?: string;
  planIds?: string[];
}

export interface UpdateCouponData {
  code?: string;
  discountStrategy?: string;
  value?: number;
  durationType?: string;
  durationMonths?: number | null;
  usageType?: string;
  affiliateId?: string | null;
  description?: string;
  maxRedemptions?: number | null;
  validFrom?: string | null;
  validUntil?: string | null;
  planIds?: string[] | null;
  isActive?: boolean;
}

export const couponsService = {
  async list(opts?: { affiliateId?: string }): Promise<Coupon[]> {
    const params = opts?.affiliateId ? { affiliateId: opts.affiliateId } : undefined;
    const { data } = await api.get<{ success: boolean; data: Coupon[] }>('/coupons', { params });
    return data.data;
  },

  async create(body: CreateCouponData): Promise<Coupon> {
    const { data } = await api.post<{ success: boolean; data: Coupon }>('/coupons', body);
    return data.data;
  },

  async update(id: string, body: UpdateCouponData): Promise<Coupon> {
    const { data } = await api.patch<{ success: boolean; data: Coupon }>(`/coupons/${id}`, body);
    return data.data;
  },

  async deactivate(id: string): Promise<Coupon> {
    const { data } = await api.post<{ success: boolean; data: Coupon }>(`/coupons/${id}/deactivate`);
    return data.data;
  },

  async delete(id: string): Promise<void> {
    const { data } = await api.delete<{ success: boolean; message?: string }>(`/coupons/${id}`);
    if (!data.success) {
      throw new Error(data.message || 'Erro ao excluir cupom');
    }
  },
};
